import React from "react";
import { formatToken } from "../../utils/format";
import { TOKEN_SYMBOL } from "../../config/config";
import "./PackageCard.css";

export default function PackageCard({
  index, label, price, isActive, canActivate,
  earned, pending,
  onActivate, loading, holdBal,
}) {
  return (
    <div className={`pkg-card pkg-tier-${index} ${isActive ? "pkg-active" : "pkg-inactive"}`}>
      <div className="pkg-tier-stripe" />
      <div className="pkg-header">
        <span className="pkg-tier-num">#{index + 1}</span>
        <span className="pkg-label">{label}</span>
        <span className={`pkg-badge ${isActive ? "badge-active" : "badge-inactive"}`}>
          {isActive ? "Active" : "Inactive"}
        </span>
      </div>

      {isActive ? (
        <>
          <div className="pkg-earned-card">
            <div className="pkg-earned-icon">&#9733;</div>
            <div className="pkg-earned-body">
              <span className="pkg-earned-label">Total Earned</span>
              <div className="pkg-earned-amount-row">
                <span className="pkg-earned-amount">{formatToken(earned)}</span>
                <span className="pkg-earned-unit">{TOKEN_SYMBOL}</span>
              </div>
            </div>
          </div>

          {holdBal !== undefined && !holdBal.isZero() && (
            <div className="pkg-hold">
              <span className="pkg-hold-label">Auto Upgrade Hold</span>
              <span className="pkg-hold-value">{formatToken(holdBal)} {TOKEN_SYMBOL}</span>
            </div>
          )}

          {pending !== undefined && !pending.isZero() && (
            <div className="pkg-pending">
              <span className="pkg-pending-label">Pending Share</span>
              <span className="pkg-pending-value">{formatToken(pending)} {TOKEN_SYMBOL}</span>
            </div>
          )}
        </>
      ) : (
        <div className="pkg-price-card">
          <span className="pkg-price-label">Price</span>
          <div className="pkg-price-amount-row">
            <span className="pkg-price-amount">{price ? formatToken(price, 18, 0) : "..."}</span>
            <span className="pkg-price-unit">{TOKEN_SYMBOL}</span>
          </div>
        </div>
      )}

      <div className="pkg-actions">
        {!isActive && (
          <button className="btn-neon" onClick={() => onActivate(index)} disabled={loading || !canActivate}>
            {loading ? "Processing..." : canActivate ? "Activate" : "Locked"}
          </button>
        )}
      </div>
    </div>
  );
}
